<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [breakpoints]="{ '1199px': '80vw', '700px': '90vw' }"
  [style]="{ width: '65vw', height: '80vh' }"
  (onHide)="closeDialog()">
  <div class="w-full">
    <p-stepper [(value)]="stepItem" [linear]="true" class="w-full">
    <!-- Étape 1 : Vérification du téléphone -->
    <p-step-item *ngIf="!meetingCreated()" [value]="1">
      <p-step>{{ 'meetings.stepper.step1.title' | translate }}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <div class="flex flex-row h-80 w-full">
            <div class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex flex-col w-full gap-2 p-8 font-medium">
              <p class="my-2">{{ 'meetings.stepper.step1.description' | translate }}</p>
              <input 
                pInputText 
                aria-label="documentTel"
                type="tel" 
                maxlength="10" 
                [placeholder]="'meetings.stepper.step1.inputPlaceholder' | translate"
                [(ngModel)]="phoneNumber" 
                (ngModelChange)="verifyPhoneNumber()" 
                class="w-full" 
            />
              <div *ngIf="phoneNumber() && !phoneNumberValid()" class="text-red-500 text-sm">{{ 'meetings.stepper.step1.invalidPhone' | translate }}</div>
            </div>
          </div>
          <div class="py-6 flex justify-end w-full">
            <p-button [disabled]="!phoneNumber() || !phoneNumberValid()" [label]="'meetings.stepper.step1.next' | translate" (onClick)="verifyPhoneNumber();activateCallback(2)" severity="contrast"/>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>

    <!-- Étape 2 : Choix du site (anciennement 1) -->
    <p-step-item *ngIf="!meetingCreated()" [value]="2">
      <p-step>{{ 'meetings.stepper.step2.title' | translate }}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <div class="flex flex-row h-80 w-full">
            <div class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex flex-col w-full gap-2 p-8 font-medium">
              <p class="my-2">{{ 'meetings.stepper.step2.description' | translate }}</p>
              <p-select
                [showClear]="true"
                [placeholder]="'meetings.stepper.step2.selectPlaceholder' | translate"
                [options]="sites()"
                [(ngModel)]="siteId"
                optionLabel="libelle"
                optionValue="id"
                styleClass="w-full"
                [emptyMessage]="'meetings.stepper.step2.emptyMessage' | translate">
              </p-select>
            </div>
          </div>
          <div class="py-6 w-full">
            <p-button [disabled]="!siteId()" [label]="'meetings.stepper.step2.next' | translate" (onClick)="goToStep(3);activateCallback(3)" severity="contrast"/>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>

    <p-step-item *ngIf="!meetingCreated()"  [value]="3">
      <p-step>{{ 'meetings.stepper.step3.title' | translate }}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <div class="flex flex-col h-70 overflow-auto w-full">
            <div
              class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-auto flex justify-center items-center font-medium gap-4 py-2 flex-wrap w-full"
            >
              <div *ngIf="intervenants().length > 1" class="w-full flex justify-center">
                <p-button [label]="'meetings.stepper.step3.noPreference' | translate" variant="outlined" severity="secondary" (click)="chooseIntervenant('0');goToStep(4);activateCallback(4)"/>
              </div>
              <div *ngIf="intervenants().length > 0" class="flex md:flex-row flex-col flex-wrap text-center justify-center w-full gap-4">
                <div *ngIf="isLoadingIntervenants()">{{ 'meetings.stepper.step3.loading' | translate }}</div>
                <button
                  *ngFor="let intervenant of intervenants()"
                  class="p-ripple p-button p-component p-button-contrast p-button-outlined"
                  type="button">
                  <div (click)="chooseIntervenant(intervenant.id);goToStep(4);activateCallback(4)">
                    <span class="p-button-label">{{ intervenant.nom }} {{ intervenant.prenom }}</span>
                    <br> <hr class="my-2">
                    <span class="p-button-label font-normal"><i class="font-normal">{{ intervenant.mission }}</i></span>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="flex py-6 gap-2 w-full">
            <p-button [label]="'meetings.stepper.step3.previous' | translate" severity="secondary" (onClick)="goToStep(2);activateCallback(2)" />
            <p-button [label]="'meetings.stepper.step3.next' | translate" (onClick)="goToStep(4);activateCallback(4)" severity="contrast" disabled/>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>

    <p-step-item *ngIf="!meetingCreated() " [value]="4">
      <p-step>{{ 'meetings.stepper.step4.title' | translate }}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <div class="flex flex-col max-h-80 overflow-auto w-full">
            <div
              class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-auto flex-col justify-center items-center font-medium w-full"
            >
              <div class="flex justify-center items-center w-full h-full">
                <p-progress-spinner *ngIf="isLoadingTypesRDV()" [ariaLabel]="'meetings.stepper.step4.loading' | translate" />
              </div>
              <p-table stripedRows [value]="typesRDV()" class="w-full overflow-auto"  [paginator]="false" [rows]="5" responsiveLayout="scroll">
                <ng-template #body let-typerdv (onClick)="chooseTypeRDV(typerdv.id);goToStep(5);activateCallback(5)">
                  <tr>
                    <td style="width: 35%; min-width: 7rem;"> {{typerdv.libelle}} </td>
                    <td style="width: 35%; min-width: 8rem;"> {{typerdv.duree}} minutes</td>
                    <td style="width: 15%;">
                      <p-button pRipple (onClick)="chooseTypeRDV(typerdv.id);goToStep(5);activateCallback(5)" type="button" [label]="'meetings.stepper.step4.validate' | translate" class="p-button p-component p-button-text p-button-outlined"></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="flex py-6 gap-2 w-full">
            <p-button [label]="'meetings.stepper.step4.previous' | translate" severity="secondary" (onClick)="goToStep(3);activateCallback(3)" />
            <p-button [label]="'meetings.stepper.step4.next' | translate" disabled (onClick)="goToStep(5);activateCallback(5)" severity="contrast"/>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>

    <p-step-item *ngIf="!meetingCreated()" [value]="5">
      <p-step>{{ 'meetings.stepper.step5.title' | translate }}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <div class="flex flex-col max-h-80 overflow-auto w-full">
            <p-progress-spinner *ngIf="isLoadingDisponibilites()" class="mx-auto" [ariaLabel]="'meetings.stepper.step5.loading' | translate" />
            <div
              *ngIf="!isLoadingDisponibilites() && (!disponibilites() || disponibilites().length === 0)"
              class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex flex-col justify-center items-center font-medium p-8 text-center w-full"
            >
              <div class="text-xl text-600">
                <i class="pi pi-calendar-times mr-2"></i>
                {{ 'meetings.stepper.step5.noAvailability' | translate }}
              </div>
              <div *ngIf="noAvailabilityMessage()" [innerHTML]="noAvailabilityMessage()" data-testid="no-availability-message"></div>
            </div>
            <div
              *ngIf="!isLoadingDisponibilites() && disponibilites() && disponibilites().length > 0"
              class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-col flex justify-center items-center font-medium w-full"
            >
              <p-panel
                *ngFor="let disponibilite of disponibilites()" class="my-3" [style.width.%]="75" [header]="disponibilite.jourFormatted" [toggleable]="true">
                <div *ngFor="let creneau of disponibilite.creneaux" class="mb-5 inline-block">
                  <p-button (onClick)="chooseHoraire(disponibilite.dateJour, creneau.heure, creneau.idsAgendasDisponibles);activateCallback(6)" class="px-2 mb-5" [label]="creneau.heure" [style]="{'width': '9em'}" severity="secondary"></p-button>
                </div>
              </p-panel>
              <div
                *ngIf="!isLoadingDisponibilites() && disponibilites() && disponibilites().length > 0 && canLoadMore()"
                class="flex justify-center mt-4 mb-2 w-full"
              >
                <p-button
                  icon="pi pi-calendar-plus"
                  [label]="'meetings.stepper.step5.showMore' | translate"
                  (onClick)="showMoreDisponibilities()"
                  severity="secondary"
                  [disabled]="clickCount() >= 2">
                </p-button>
              </div>
            </div>
          </div>
          <div class="py-6 w-full">
            <p-button [label]="'meetings.stepper.step5.previous' | translate" severity="secondary" (onClick)="goToStep(4);activateCallback(4)" />
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>

    <p-step-item *ngIf="!meetingCreated()" [value]="6">
      <p-step>{{ 'meetings.stepper.step6.title' | translate }}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <div *ngIf="createLoading" class="flex justify-center">
            <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
          </div>
          <div *ngIf="!createLoading" class="flex flex-col max-h-80 overflow-auto w-full" style="height: 28rem">
            <div
              class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-col flex justify-center items-center font-medium my-4 p-6 w-full"
            >
              <h3 class="text-xl font-bold mb-4">{{ 'meetings.stepper.step6.recap' | translate }}</h3>
              <div class="text-left w-full">
                <p><strong><u>{{ 'meetings.stepper.step6.appointment' | translate }} :</u> </strong> {{typeRdvDisplay()}}</p> <br>
                <p><strong>{{ 'meetings.stepper.step6.dateTime' | translate }} :</strong> {{ horaire() | date:'EEEE d MMMM y à HH:mm':'fr'  }}</p>
                <p *ngIf="this.intervenantId() != '0'" ><strong>{{ 'meetings.stepper.step6.with' | translate }} : </strong> {{ intervenantDisplay() }}</p>
                <p *ngIf="!typeRdvIsVisio()"><strong>{{ 'meetings.stepper.step6.onSite' | translate }} : </strong>{{ siteDisplay()}}</p>
                <p *ngIf="typeRdvIsVisio()"><strong>{{ 'meetings.stepper.step6.visio' | translate }}</strong></p>
              </div>
            </div>
          </div>
          <div *ngIf="!createLoading" class="flex py-6 gap-2 w-full">
            <p-button [label]="'meetings.stepper.step6.previous' | translate" severity="secondary" (onClick)="goToStep(5);activateCallback(5)" />
            <p-button [label]="meetingId != null ? ('meetings.stepper.step6.update' | translate) : ('meetings.stepper.step6.create' | translate)" (onClick)="meetingId != null ? updateMeeting() : validateMeeting(activateCallback)" />
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>

    <!-- Étape 7 : Succès -->
    <p-step-item *ngIf="meetingCreated() && isMeetingIAEnabled()" [value]="7">
      <p-step aria-label="meeting_ia">{{ 'meetings.stepper.step7.title' | translate }}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <div class="flex flex-col overflow-auto w-full" style="height: 46rem">
            <div
              class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-col flex justify-center items-center font-medium my-4 p-6 w-full"
            >
              <h3 class="text-xl font-bold mb-4">{{ 'meetings.stepper.step7.success' | translate }}</h3>
              <div class="text-left w-full flex flex-col items-center">
                <div class="mb-4 flex flex-col items-center">
                  <span class="text-3xl">🤖✨</span>
                  <h4 class="text-xl font-semibold mt-2 mb-1 text-pink-700">{{ 'meetings.stepper.step7.prepareTitle' | translate }}</h4>
                  <p class="text-base text-gray-700 mb-2 text-center max-w-md" [innerHTML]="'meetings.stepper.step7.prepareText' | translate">
                  </p>
                </div>
                <div class="flex gap-4 mt-2">
                  <button
                    type="button"
                    class="px-6 py-2 p-button-transparent rounded-full bg-pink-500 hover:bg-pink-600 text-white font-bold shadow transition-all duration-150 ease-in-out"
                    (click)="navigateToPrepareMeetingAI(typeRdvDisplay(), meetingId!, phoneNumber())"
                  >
                    {{ 'meetings.stepper.step7.yes' | translate }}
                  </button>
                  <p-button (onClick)="closeDialog()" [label]="'meetings.stepper.step7.no' | translate" class="px-6 py-2 p-button-transparent rounded-full bg-gray-200 hover:bg-gray-300 text-gray font-bold shadow transition-all duration-150 ease-in-out"/>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>
    </p-stepper>
  </div>
</p-dialog>
